import React from 'react';
import {useRoute} from '@react-navigation/native';
import {WithdrawWebSuccessPage} from '@fe-progressive/package-progressive/withdraw';
import {goBack, goCS, goTo, toPriceStr} from '@/utils';
import globalStore from '@/services/global.state';

const WithdrawSuccess = () => {
  const route = useRoute<any>();
  const amount = Number(route.params?.amount || 0);

  return (
    <WithdrawWebSuccessPage
      amount={amount}
      formatAmount={value =>
        toPriceStr(Number(value || 0), {
          thousands: true,
          spacing: true,
          fixed: 2,
          currency: globalStore.currency,
        })
      }
      onBack={goBack}
      onCustomerService={goCS}
      onRecords={() => goTo('WithdrawRecords')}
      onFinish={() => {
        globalStore.updateAmount.next({});
        goTo('Withdraw');
      }}
    />
  );
};

export default WithdrawSuccess;
